import enUS from 'antd/es/locale/en_US';
import ruRU from 'antd/es/locale/ru_RU';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import localeData from 'dayjs/plugin/localeData';
import updateLocale from 'dayjs/plugin/updateLocale';
import i18next from 'i18next';

const instance = dayjs;

instance.extend(updateLocale);
instance.extend(isBetween);
instance.extend(localeData);

const setDayjsLocale = (lng: string): void => {
  dayjs.updateLocale('en', {
    monthsShort: i18next.t('Shared:monthNames', { returnObjects: true }),
    weekdaysMin: i18next.t('Shared:weekdaysMin', { returnObjects: true }),
    weekStart: 0,
  });

  dayjs.updateLocale('ru', {
    monthsShort: i18next.t('Shared:monthNames', { returnObjects: true }),
    months: i18next.t('Shared:monthNames', { returnObjects: true }),
    weekdaysMin: i18next.t('Shared:weekdaysMin', { returnObjects: true }),
    weekStart: 0,
  });

  dayjs.locale(lng);
};

const ruLocale = {
  ...ruRU,
  Calendar: {
    ...ruRU.Calendar,
    lang: {
      ...ruRU.Calendar?.lang,
      shortMonths: instance().locale('ru').localeData().months(),
      firstDayOfWeek: 0,
    },
  },
};

const enLocale = {
  ...enUS,
  Calendar: {
    ...enUS.Calendar,
    lang: {
      ...enUS.Calendar?.lang,
      shortMonths: instance().locale('en').localeData().months(),
      firstDayOfWeek: 0,
    },
  },
};

export { instance as dayjs, setDayjsLocale, enLocale as enUS, ruLocale as ruRU };
